import React from 'react'

import { Link as LinkStyled } from './Link.styles'

export default function Link({ children, to }) {
  return <LinkStyled to={to}>{children}</LinkStyled>
}
